// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"6d6fe73b","187":"b3c182e5","715":"07ea0750","787":"9549e2ab","857":"94de6ccd","896":"73ec4e89"}[chunkId] + ".chunk.js";
};